import {forwardRef} from 'react'
import type {IconProps} from '../types'

export const ExclamationCircleIcon = forwardRef<SVGSVGElement, IconProps>(
  ({size = 20, color = 'currentColor', className, ...props}, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path
        id="Icon"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6 12C21.6 17.302 17.302 21.6 12 21.6C6.69809 21.6 2.40002 17.302 2.40002 12C2.40002 6.69809 6.69809 2.40002 12 2.40002C17.302 2.40002 21.6 6.69809 21.6 12ZM13.2 16.8C13.2 17.4628 12.6628 18 12 18C11.3373 18 10.8 17.4628 10.8 16.8C10.8 16.1373 11.3373 15.6 12 15.6C12.6628 15.6 13.2 16.1373 13.2 16.8ZM12 6.00002C11.3373 6.00002 10.8 6.53728 10.8 7.20002V12C10.8 12.6628 11.3373 13.2 12 13.2C12.6628 13.2 13.2 12.6628 13.2 12V7.20002C13.2 6.53728 12.6628 6.00002 12 6.00002Z"
        fill={color}
      />
    </svg>
  ),
)

ExclamationCircleIcon.displayName = 'ExclamationCircleIcon'
